import React from "react";
import {ISelectFieldValue, IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import MultiSelectDialog from "../modalDropdown/MultiSelectDialog";
import {EColumnKey} from "../../../../views/OptionsView/OptionsViewUtils";
import {Icon, Label} from "semantic-ui-react";

interface TextFlagCellProps extends IVirtualizedTableCellComponentProps {

}

interface TextFlagCellState {
    toggleModal: boolean;
}

export default class TextFlagCell extends React.Component<TextFlagCellProps, TextFlagCellState> {
    constructor(props: TextFlagCellProps) {
        super(props);
        this.state = {
            toggleModal: false,
        };
    }

    saveChange = (selectedFlags: any[]) => {
        const oldValues = this.props.value.value;

        if (!(oldValues.length === selectedFlags.length
                && selectedFlags.every((flag, index) => oldValues[index] === flag))) {
            this.setState({toggleModal: false});
            this.props.onChange(selectedFlags);
        }
    }

    public render() {
        const dropdownValue: ISelectFieldValue = this.props.value;

        return (
            <React.Fragment>
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        justifyContent: 'center'
                    }}
                    onClick={()=> !this.props.readOnly && this.setState({toggleModal: true})}
                >
                    {
                        // @ts-ignore it will never be undefined
                        dropdownValue.value && dropdownValue.value.length > 0
                            ?
                            // @ts-ignore it will never be undefined
                            dropdownValue.value.map(flag =>
                                <Label key={flag.objectId} color='grey' tag={true} style={{marginBottom: 2}}>
                                    {flag.textLabel}
                                </Label>
                            )
                            :
                            <div
                                style={{
                                    cursor: this.props.readOnly ? "default" : "pointer",
                                    opacity: this.props.readOnly ? 0.4 : 1
                                }}
                            >
                                <Icon name='tags'/>
                                {this.props.t('OPTIONS_VIEW:ADD_FLAG')}
                            </div>
                    }
                </div>
                {this.state.toggleModal &&
                    <MultiSelectDialog
                        open={this.state.toggleModal}
                        title={this.props.t('OPTIONS_VIEW:EDIT_FLAGS_TITLE')}
                        dialogText={this.props.t('OPTIONS_VIEW:EDIT_FLAGS_DESCRIPTION')}
                        cellKey={EColumnKey.FlagKey}
                        value={{
                            options: dropdownValue.options,
                            // @ts-ignore it will never be undefined
                            value: dropdownValue.value && dropdownValue.value.map(flag => flag.objectId),
                        }}
                        onChange={this.saveChange}
                        onClose={() => this.setState({toggleModal: false})}
                        customStyle={{width:'85%'}}
                    />
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/TextFlagCell.tsx